import React, { PureComponent } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { getSentimentColor, numberWithCommas } from "../utils";
import moment from "moment-timezone";
import UpIcon from "../../../../../assets/svg/percentage_arrow.svg";
import DownIcon from "../../../../../assets/svg/arrow-down.svg";
class GeneraltrendsChart extends PureComponent {
    chartComponent = React.createRef();
    state = {};

    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount) {
    //         this.chartComponent.current.chart.setSize(null, null);
    //         this.chartComponent.current.chart.reflow();
    //     }
    // }

    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent.current.chart.setSize(null, null);
                this.chartComponent.current.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }

    getOptions = () => {
        let data = this.props.data.chartData;
        let self = this;
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let tzo = JSON.parse(localStorage.company).user_timezone * -60;

        let plotComaprisiondata;

        let plotComaprisiondataCondition = this.props.comparisionData && this.props.comparisionData.chartData.length >= this.props.data.chartData.length;

        if (plotComaprisiondataCondition && this.props.data) {
            plotComaprisiondata = JSON.parse(JSON.stringify(this.props.data.chartData));

            this.props.comparisionData.chartData.forEach((element, ind) => {
                if (plotComaprisiondata[ind]) {
                    plotComaprisiondata[ind].originalX = plotComaprisiondata[ind].x;
                    plotComaprisiondata[ind].x = element.x;
                }
            });
        } else {
            if (this.props.comparisionData) {
                plotComaprisiondata = JSON.parse(JSON.stringify(this.props.comparisionData.chartData));
                this.props.data &&
                    this.props.data.chartData.forEach((element, ind) => {
                        if (plotComaprisiondata[ind]) {
                            plotComaprisiondata[ind].originalX = plotComaprisiondata[ind].x;
                            plotComaprisiondata[ind].x = element.x;
                        }
                    });
            }
        }

        let serObj = this.props.comparisionData
            ? [
                  {
                      name: `${moment(this.props.data.date.start_date).format("DD MMM YYYY")} - ${moment(this.props.data.date.end_date).format("DD MMM YYYY")}`,

                      data: this.props.comparisionData.chartData.length >= this.props.data.chartData.length ? plotComaprisiondata : this.props.data.chartData,

                      color: getSentimentColor("positive"),
                  },
                  {
                      name: `${moment(this.props.comparisionData.date.start_date).format("DD MMM YYYY")} - ${moment(
                          this.props.comparisionData.date.end_date,
                      ).format("DD MMM YYYY")}`,

                      data:
                          this.props.comparisionData.chartData.length < this.props.data.chartData.length
                              ? plotComaprisiondata
                              : this.props.comparisionData.chartData,
                      // xAxis: 1,
                      color: getSentimentColor("positive") + "55",
                  },
              ]
            : [
                  {
                      name: "General trends",
                      data: this.props.data.chartData,
                      color: getSentimentColor("positive"),
                  },
              ];

        const optionsOverTime = {
            chart: {
                type: "spline",
                backgroundColor: "transparent",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            credits: {
                enabled: false,
            },
            title: {
                text: " ",
            },
            legend: {
                enabled: this.props.showLegend,
                itemStyle: {
                    fontWeight: 500,
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "normal",
                },
                alignColumns: false,
            },
            tooltip: {
                followPointer: true,
                followTouchMove: true,
                shared: plotComaprisiondata ? true : false,
                crosshairs: true,
                backgroundColor: "#fff",
                borderRadius: 6,
                useHTML: true,

                formatter: function () {
                    if (plotComaprisiondata) {
                        let str = "";
                        let temp = "";
                        let ComapareVal1;
                        let ComapareVal2;
                        let dateCompare;
                        let showPercent = true;
                        for (let i = 0; i < this.points.length; i++) {
                            ComapareVal1 = this.points[0].y;
                            ComapareVal2 = this.points[1]?.y;
                            dateCompare = this.points[1]?.point.options.originalX > this.points[1]?.point.options.x;
                            let firstColorPoint = this.points[1]?.color.endsWith("55");
                            let secondColorPoint = this.points[0]?.color.endsWith("55");

                            if ((firstColorPoint && secondColorPoint) || (!secondColorPoint && !firstColorPoint)) {
                                showPercent = false;
                            }
                            temp = `<b>${moment(
                                this.points[i].point.options.originalX ? this.points[i].point.options.originalX : this.points[i].point.options.x,
                            )
                                .tz(tz)
                                .format(
                                    "LLLL",
                                )}</b><br/><div style="margin-bottom:10px;"><span style="margin-right:10px;display:inline-block;width:8px;height:8px;background-color:${
                                this.points[i].color
                            };border-radius:10px" ></span>
                          
                            <b>${numberWithCommas(this.points[i].y)}</b> </div>`;

                            str += temp;
                        }
                        if (this.points.length == 2 && showPercent) {
                            str += `${
                                ComapareVal1 < ComapareVal2
                                    ? `<div> <div style="display:flex;align-item:center"><b>${
                                          ComapareVal1 !== 0 ? (((ComapareVal2 / ComapareVal1).toFixed(2) - 1) * 100).toFixed(2) + "%" : "NA"
                                      }</b>
                                   
                                <img src=${dateCompare ? UpIcon : DownIcon} width="16px" height="16px" style="margin-left:5px;transform:${
                                          dateCompare && "rotate(180deg)"
                                      }" />
                                </div>
                             
                            
                            
                                
                                </div>`
                                    : ComapareVal1 > ComapareVal2
                                    ? `<div> <div style="display:flex;align-item:center"><b>${
                                          ComapareVal2 !== 0 ? (((ComapareVal1 / ComapareVal2).toFixed(2) - 1) * 100).toFixed(2) + "%" : "NA"
                                      }</b>
                                   
                                    <img src=${dateCompare ? DownIcon : UpIcon} width="16px" height="16px" style="margin-left:5px;transform:${
                                          !dateCompare && "rotate(180deg)"
                                      }" />
                                    </div>
                                 
                                
                                
                                    
                                    </div>`
                                    : ""
                            }`;
                        }

                        return str;
                    } else {
                        return `${moment(this.x).tz(tz).format("LLLL")}<br/>${this.point?.series?.name}: <b>${numberWithCommas(this.y)}</b>`;
                    }
                },
            },
            xAxis: {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%l:%M %p",
                    second: "%l:%M %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
                labels: {
                    style: {
                        textTransform: "normal",
                    },
                },
            },
            yAxis: {
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                title: {
                    text: ``,
                },
            },
            series: serObj,
            plotOptions: {
                // spline: {
                //     point: {
                //         events: {
                //             contextmenu: function (e) {
                //                 e.preventDefault();
                //                 self.addContextMenuListener(e.x, e.y, this);
                //             },
                //         },
                //     },
                // },
                series: {
                    marker: {
                        radius: 4,
                        symbol: "circle",
                    },
                },
            },
            time: {
                timezoneOffset: tzo,
            },
        };

        return optionsOverTime;
    };

    render() {
        return (
            <HighchartsReact
                highcharts={Highcharts}
                options={this.getOptions()}
                ref={this.chartComponent}
                containerProps={{ style: { width: "100%", height: "100%" } }}
            />
        );
    }
}

export default GeneraltrendsChart;
